<p-dialog
  class="pdf-viewer-dialog"
  [(visible)]="visible"
  [modal]="true"
  [resizable]="true"
  [style]="{width: '95vw', height: '95vh'}"
  [maximizable]="true"
  (visibleChange)="closeDialog()"
>
  <!-- Custom Header with Language Selector -->
  <ng-template pTemplate="header">
    <div class="pdf-viewer-header">
      <span class="pdf-title">{{title}}</span>
      <div class="pdf-controls">
        <app-language-selector (languageChanged)="onLanguageChanged($event)"></app-language-selector>
      </div>
    </div>
  </ng-template>

  <div class="pdf-viewer-container">
    <!-- Loading overlay -->
    <div *ngIf="loading" class="loading-overlay">
      <div class="loading-container">
        <div class="loading-spinner"></div>
        <p>Loading PDF...</p>
      </div>
    </div>

    <!-- Error state -->
    <div *ngIf="error" class="error-container">
      <div class="error-icon">⚠️</div>
      <p>Error loading PDF document</p>
      <p class="error-details">Please check your connection and try again, or contact support if the problem persists.</p>
    </div>

    <!-- PDF Viewer with Default Controls -->
    <ngx-extended-pdf-viewer
      *ngIf="pdfSrc && !error"
      [src]="pdfSrc"
      [textLayer]="true"
      [enablePrint]="false"
      [useBrowserLocale]="true"
      [sidebarVisible]="false"
      [showPrintButton]="false"
      [showDownloadButton]="false"
      [showRightToolbar]="false"
      [showCommentEditor]="false"
      [showDrawEditor]="false"
      [showHandToolButton]="false"
      [showSecondaryToolbarButton]="false"
      [showPresentationModeButton]="false"
      [showOpenFileButton]="false"
      [showBookmarkButton]="false"
      [showSignatureButton]="false"
      [showTextSelectionButton]="false"
      [showRotateButton]="false"
      [showScrollingButton]="false"
      [showSpreadButton]="false"
      [showPropertiesButton]="false"
      [showHighlightEditor]="false"
      [showTextEditor]="false"
      [showImageEditor]="false"
      [showStampEditor]="false"
      [showInkEditor]="false"
      [showAnnotationEditor]="false"
      [showAnnotationTools]="false"
      [enableAnnotations]="false"
      [page]="1"
      [initialPage]="1"
      [resetZoomButton]="false"
      [maxZoom]="1.5"
      [zoom]="'auto'"
      [showZoomDropdown]="false"
      (pdfLoaded)="onPdfLoaded($event)"
      (pdfLoadingFailed)="onPdfError($event)"
      class="pdf-viewer">
    </ngx-extended-pdf-viewer>
  </div>
</p-dialog>
